<template>
    <div v-if="productInfo != null" class="tab-pane" id="comments" role="tabpanel" aria-expanded="false">
        <article id="reviewsContainer">
            <div class="row">
                <div class="main-add-opinion col-12">
                    <h2>شما هم می‌توانید در مورد این کالا نظر بدهید.</h2>
                    <p>برای ثبت نظر، لازم است ابتدا وارد حساب کاربری خود شوید.</p>
                    <div class="parent-btn">
                        <router-link :to="{ name: 'review' , params: { productId: productInfo.Id} }" rel="nofollow" class="dk-btn dk-btn-info">
                            افزودن نظر جدید
                        </router-link>
                    </div>
                    <p></p>
                </div>
            </div>
            <hr v-if="productReviewInfo.TotalCount > 0"/>
            <h2 v-if="productReviewInfo.TotalCount > 0" class="param-title">
                نظرات کاربران
                <span>{{productReviewInfo.TotalCount}} نظر</span>
            </h2>
            <div class="comments-area default">
                <div class="row">
                    <div class="col-12">
                        <div :class="{'loader':!showLoaderRewiew}" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%">
                            <img style="position:absolute;top:35%;left:40%;z-index:100" src="/assets/img/loader/loader.svg" />
                        </div>
                        <ol class="comment-list">
                            <li v-for="inforeview in productReviewInfo.FilteredReviews">
                                <div class="comment-body">
                                    <div class="comment-author">
                                        <img alt="" src="/assets/img/default-avatar.png" class="avatar"><cite class="fn">{{inforeview.CustomerName}}</cite>
                                        <span class="says">گفت:</span>
                                    </div>

                                    <div class="commentmetadata">
                                        <a>
                                            {{inforeview.RegDateTime}}
                                        </a>
                                    </div>
                                    <div class="comment-p">
                                        <span class="title title-review">{{inforeview.Title}}</span>
                                        <p v-text="inforeview.Text"></p>
                                    </div>
                                </div>
                                <hr />
                            </li>

                        </ol>
                    </div>
                </div>
            </div>
        </article>
        <div id="reviewsPaging" class="pager default text-center"></div>
    </div>
</template>

<script>
    import { httpPromise } from "../../module/httpUtility";
    export default {
        data() {
            return {
                productReviewInfo: {},
                showLoaderRewiew: false
            }
        },
        watch: {
            isLoadReviews(newValue, oldValue) {
                if (newValue == true) {
                    this.sendToServer(0);
                }
            }
        },
        props: {
            productInfo: {
                type: Object,
            },
            isLoadReviews: {
                type: Boolean,
            }, 
        },  
        methods: {
            sendToServer(pageNum) {
                this.showLoaderRewiew = true;
                httpPromise(this, '/v1/ProductManagement/ProductReviews/Read', 'get', { ProductId: this.$route.params.productId, Page: pageNum },
                    response => {
                        this.productReviewInfo = response.data.Value;
                        this.createPaging(response.data.Value.TotalCount, response.data.Value.Page);
                        this.showLoaderRewiew = false;
                        this.scrollTop();
                    },
                    response => {
                        this.showLoaderRewiew = false;
                    }
                );
            } , 
             
            createPaging(totalDataCount, pageNumber) {
                var component = this; 
                $(function () {
                    try {
                        $('#reviewsPaging').pagination('destroy');
                    } catch  { }
                    var dataSource = [];
                    for (var i = 1; i <= totalDataCount; i++)
                        dataSource.push(i);
                    if (dataSource != null && dataSource.length > 0) {
                        var container = $('#reviewsPaging').pagination({
                            dataSource: dataSource,
                            pageSize: 10,
                            pageNumber: pageNumber,
                            classPrefix: 'pager',
                            ulClassName: 'pager-items',
                            activeClassName: 'is-active',
                        });
                        container.addHook('afterPaging', function () {
                            var pageNum = container.pagination('getSelectedPageNum');
                            component.sendToServer(pageNum);
                        });
                    }
                 
                });
            },
            scrollTop() {
                $(function () {
                    var top = $('#reviewsContainer').offset().top;
                    $('html, body').animate({ scrollTop: top }, 800, 'easeInExpo');
                });
            } 
        }
    }
</script>

<style scoped>
    .title-review {
        font-size:18px;
    }
    /*بررسی گردد*/
    .comment-p p {
        text-align: justify;
    }
    /*بررسی گردد*/
    .main-add-opinion .dk-btn {
        color: #fff;
        font-size: 16px;
        padding: 13px 20px;
    }

    .main-add-opinion {
        padding-top: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

        .main-add-opinion h2 {
            font-size: 22px;
            margin-bottom: 0;
        }

        .main-add-opinion p {
            color: #777;
        }

    ol, ol li {
        width: 100%;
    }

    .comments-area ol.comment-list li .comment-body {
        background-color: #eee;
        border-radius:5px;
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .title-review {
            font-size: 15px;
        }
        .main-add-opinion h2 {
            font-size: 16px;
        }

        .comment-p p {
            font-size: 13px;
        }

        .comments-area ol.comment-list li .comment-body {
            padding: 20px 10px 20px 20px;
        }

        .comments-area ol.comment-list li img.avatar {
            width: 45px;
            height: 45px;
        }

        .comments-area ol.comment-list {
            padding-right: 15px;
        }

            .comments-area ol.comment-list li .comment-author {
                padding-right: 10px;
            }
    }
</style>